const VISITOR_STORAGE_KEY = 'fm-visitor-v1';
const VISIT_GAP_MS = 30 * 60 * 1000;
function createVisitorId() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    return `v_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}
function readRecord() {
    try {
        const raw = localStorage.getItem(VISITOR_STORAGE_KEY);
        if (!raw) {
            return null;
        }
        const parsed = JSON.parse(raw);
        if (typeof parsed.visitorId !== 'string' ||
            typeof parsed.firstSeenAt !== 'string' ||
            typeof parsed.lastSeenAt !== 'string' ||
            typeof parsed.visitCount !== 'number') {
            return null;
        }
        return {
            visitorId: parsed.visitorId,
            firstSeenAt: parsed.firstSeenAt,
            lastSeenAt: parsed.lastSeenAt,
            visitCount: parsed.visitCount,
        };
    }
    catch {
        return null;
    }
}
function writeRecord(record) {
    try {
        localStorage.setItem(VISITOR_STORAGE_KEY, JSON.stringify(record));
    }
    catch {
        // Storage unavailable — visitor stays ephemeral for this session.
    }
}
function toProfile(record) {
    return {
        ...record,
        kind: record.visitCount > 1 ? 'returning' : 'first',
    };
}
/** Touch visitor record for this page load. Counts a new visit after 30m idle. */
export function touchVisitorProfile(now = new Date()) {
    const existing = readRecord();
    const isoNow = now.toISOString();
    if (!existing) {
        const created = {
            visitorId: createVisitorId(),
            firstSeenAt: isoNow,
            lastSeenAt: isoNow,
            visitCount: 1,
        };
        writeRecord(created);
        return toProfile(created);
    }
    const lastSeenMs = Date.parse(existing.lastSeenAt);
    const isNewVisit = !Number.isFinite(lastSeenMs) || now.getTime() - lastSeenMs >= VISIT_GAP_MS;
    const next = {
        ...existing,
        lastSeenAt: isoNow,
        visitCount: isNewVisit ? existing.visitCount + 1 : existing.visitCount,
    };
    writeRecord(next);
    return toProfile(next);
}
export function getVisitorProfile() {
    const record = readRecord();
    return record ? toProfile(record) : null;
}
export function clearVisitorProfile() {
    try {
        localStorage.removeItem(VISITOR_STORAGE_KEY);
    }
    catch {
        // ignore
    }
}
//# sourceMappingURL=visitor-storage.js.map